import { render } from "./cardComponent.vue?vue&type=template&id=636b0938&scoped=true"
import script from "./cardComponent.vue?vue&type=script&lang=js"
export * from "./cardComponent.vue?vue&type=script&lang=js"

import "./cardComponent.vue?vue&type=style&index=0&id=636b0938&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/fundraise/front_end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-636b0938"]])

export default __exports__